import styled from 'styled-components';
import { themeGet } from '@magalu/stereo-ui-styles';
import Box from '../../../atoms/Box';
import Text from '../../../atoms/Text';
export const Container = styled(Box)``;
export const ProfitLabel = styled(Text)`
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  line-height: ${props => themeGet('lineHeights.input')(props)}em;
`;